/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
const a="20250407",e="04d2b42da93678ca718b23aaf7e216985f10fa8e";export{a as buildDate,e as commitHash};
